import {DeletePopup} from "components/Admin/Pages/DeletePopup/DeletePopup";
import {capService} from "../../../services/capService";

export const CapDelete = () => {
  return (
    <DeletePopup
      queryKey="caps"
      deleteQuery={capService.delete}
      onSuccessNavigate="/users"
    />
  );
};
